import React from 'react';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getIcon } from '../../utils/IconHandler';

const TableRefreshButton = ({ onClick, loading = false, title, size = 'small' }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={title || t('refresh') || 'Actualizar'}>
      <span>
        <IconButton
          size={size}
          onClick={onClick}
          disabled={loading}
          sx={{
            width: 44,
            height: 44,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            flexShrink: 0,
            '& ion-icon': {
              fontSize: 20,
            },
          }}
        >
          {loading ? <CircularProgress size={18} /> : getIcon('refresh')}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default TableRefreshButton;
